import {
  getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationFetcher,
  getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

/**
 * 利用者更新APIを実行するカスタムフック（口座連携版）
 *
 * @param threeLetterCode - パートナーコード
 * @param userId - 更新対象の利用者ID
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePutPartnerAdminsUserBankAccount = (
  threeLetterCode: string,
  userId: number,
  options?: {
    onSuccess?: (data: PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody) => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationKey(threeLetterCode, userId),
    getPutApiV1ThreeLetterCodePartnerAdminsUsersUserIdMutationFetcher(threeLetterCode, userId),
    options
  );
};
